// extracted by mini-css-extract-plugin
export default {"Logo":"Logo__Logo__uX5yw"};